<app-shared-dialog
  [title]="(mode === 'create' ? 'warehouse.add_warehouse' : 'warehouse.edit_warehouse') | translate"
  (confirm)="save()"
  (cancel)="cancel()"
  [options]="{
    titleIcon: 'edit_icon',
    titleIconColor: 'primary',
    confirmText: (mode === 'create' ? 'common.proceed' : 'common.update') | translate,
    confirmButtonStyle: 'primary-btn',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end',
    cancelText: 'common.cancel' | translate,
    cancelButtonStyle: 'danger-btn',
    isSaving: (isSaving$ | async) || false
  }"
>
  <form [formGroup]="form">
    <div class="form-content">
      <div class="form-row">
        <div class="standard-input" [class.has-error]="form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)">
          <label class="label" for="name">{{ "warehouse.form.name" | translate }}</label>
          <input type="text" formControlName="name" [placeholder]="'warehouse.form.name_placeholder' | translate" />
          <div class="error" *ngIf="form.get('name')?.invalid && (form.get('name')?.touched || form.get('name')?.dirty)">
            <small *ngIf="form.get('name')?.hasError('required')">{{ "warehouse.validation.name.required" | translate }}</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="standard-input" [class.has-error]="form.get('address')?.invalid && (form.get('address')?.touched || form.get('address')?.dirty)">
          <label class="label" for="address">{{ "warehouse.form.address" | translate }}</label>
          <input type="text" formControlName="address" [placeholder]="'warehouse.form.address_placeholder' | translate" id="apartment" (focus)="addressAutoComplete($event)" />
          <div class="error" *ngIf="form.get('address')?.invalid && (form.get('address')?.touched || form.get('address')?.dirty)">
            <small *ngIf="form.get('address')?.hasError('required')">{{ "warehouse.validation.address.required" | translate }}</small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div
          class="standard-input"
        >
          <div class="label">
            <label for="internal_id">{{ "warehouse.form.internal_id" | translate }}</label>
            <span class="hint">{{ "warehouse.form.internal_id_hint" | translate }}</span>
          </div>
          <input type="text" formControlName="external_id" [placeholder]="'warehouse.form.internal_id_placeholder' | translate" />
        </div>
      </div>
      <div class="form-row">
        <div class="standard-switch">
          <div class="label">
            <label for="is_primary">{{ "warehouse.form.is_primary" | translate }}</label>
            <span class="hint">{{ "warehouse.form.is_primary_hint" | translate }}</span>
          </div>
          <label class="switch">
            <input type="checkbox" formControlName="is_primary" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </form>
</app-shared-dialog>
